/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Org_Not_Confirmed_BodyInputs */



/**
* | output |
* | --- |
* | "Your organization is scheduled to start on {date}, once your contract has been confirmed. Your partner will let you know if anything changes." |
*
* @param {Org_Not_Confirmed_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_not_confirmed_body = /** @type {((inputs: Org_Not_Confirmed_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Not_Confirmed_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihre Organisation soll am ${i?.date} starten, sobald Ihr Vertrag bestätigt ist. Ihr Partner informiert Sie, falls sich etwas ändert.`)
	return /** @type {LocalizedString} */ (`Your organization is scheduled to start on ${i?.date}, once your contract has been confirmed. Your partner will let you know if anything changes.`)
});